// extracted by mini-css-extract-plugin
export default {"CardDeck":"Home_CardDeck__Cf8vh","Home__aboutUs":"Home_Home__aboutUs__FKcSB","Home__videoSection":"Home_Home__videoSection__Tc6KY"};